export default "__VITE_ASSET__CN$2oT$W__"